import { useState, useEffect } from 'react';
import axios from "axios";
import { useAuth } from '../../contexts/AuthContext';
import ThirdSidebar from './thirdsidbar';
import CaraUserSidebar from './carausersidbar';
import VRMSidebar from '../VirtualRiskManager/Dashboard/VrmSidbar';
import OffSecStaffSidebar from '../OffSecStaffPortal/OffSecStaffSidebar';
// Removed sidebar-specific CSS to revert to global App.css

const API_URL = process.env.REACT_APP_API_URL;
console.log("API_URL =>", API_URL); // For debugging

const Sidebar = () => {
  const { tprmUser, caraUser, tprmUseruser } = useAuth();
  console.log("tprmUseruser =>", tprmUseruser?.user_type);

  const roleFromStorage = (localStorage.getItem("role") || "").toUpperCase();
  const userTypeFromStorage = localStorage.getItem("user_type");
  const userType = String(
    tprmUser?.user_type ||
    caraUser?.user_type ||
    tprmUseruser?.user_type ||
    userTypeFromStorage ||
    ""
  );
  console.log("Determined userType =>", userType);
  console.log("user =>", caraUser?.capabilities);
  console.log("user =>", caraUser?.user_type);

  const [user, setUser] = useState(null);
  const [activeItem, setActiveItem] = useState("");
  useEffect(() => {
    const $ = window.$;

    $('.sidebar').off('click.treeview').on('click.treeview', '.has-treeview > a', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevent double trigger
      e.stopPropagation(); // Also stop bubbling

      const parent = $(this).parent();
      const submenu = parent.find('> .nav-treeview');

      const isOpen = parent.hasClass('menu-open');

      if (isOpen) {
        // Close the current
        parent.removeClass('menu-open menu-is-opening');
        submenu.css('display', 'none');
      } else {
        // Close all others
        $('.has-treeview.menu-open')
          .not(parent)
          .removeClass('menu-open menu-is-opening')
          .find('> .nav-treeview')
          .css('display', 'none');

        // Open current
        parent.addClass('menu-open menu-is-opening');
        submenu.css('display', 'block');
      }
    });

    return () => {
      $('.sidebar').off('click.treeview');
    };
  }, []);


  useEffect(() => {
    // Fetch logged-in user details
    axios
      .get(`${API_URL}api/userr-detail/`, { withCredentials: true })
      .then((response) => {
        console.log(" userr-detail response =>", response.data);

        if (response.data.first_name) {
          setUser(response.data); // Store user details in state
          localStorage.setItem("role", response.data.role); // Store role locally
          localStorage.setItem("user", JSON.stringify(response.data)); // Add this line

        } else {
          console.error("No user data found:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  }, []);

  const handleMenuClick = (item) => {
    setActiveItem(item);
  };

  return (
    <>
      {userType === "14" || userType === "19" ? (
        <ThirdSidebar />
      ) : userType === "1" || userType === "2" || userType === "16" || userType === "17"
        || userType === "18"
        ?
        (
          <CaraUserSidebar />
        ) : userType === "15" || userType === "20" || roleFromStorage === "VRM" ? (
          <VRMSidebar />
        ) : roleFromStorage === "OFFSEC_STAFF" ? (
          <OffSecStaffSidebar />
        ) : null}
    </>
  );
};

export default Sidebar;
